/**
 * Adopt-only SSO cookie reader (ADR 0038/0053). The campaign app reads the
 * shared parent-domain end-user id token but is never an auth authority — login
 * is delegated to accounts-web.
 */
const SSO_COOKIE = 'wa_enduser_idtoken'

export function readSsoIdToken(): string | null {
  try {
    const match = document.cookie
      .split('; ')
      .find((c) => c.startsWith(`${SSO_COOKIE}=`))
    if (!match) return null
    const token = decodeURIComponent(match.slice(SSO_COOKIE.length + 1))
    // Degrade gracefully on an expired token.
    const payload = JSON.parse(atob(token.split('.')[1] ?? ''))
    if (payload.exp && payload.exp * 1000 < Date.now()) return null
    return token
  } catch {
    return null
  }
}

export function isAuthenticated(): boolean {
  return readSsoIdToken() != null
}

/** accounts-web base URL for the login round trip (env-configured). */
export function accountsBaseUrl(): string {
  return import.meta.env.VITE_ACCOUNTS_URL || 'https://accounts.polux.weapps.net'
}

/** The opaque account id (`sub`) of the adopted session — carried on a product hand-off so the app can
 *  tell whether it is signed in as the same account (Account Mismatch Notice, ADR 0162 §3). Never an e-mail. */
export function ssoAccountSub(): string | null {
  const token = readSsoIdToken()
  if (!token) return null
  try { return (JSON.parse(atob(token.split('.')[1])) as { sub?: string }).sub ?? null } catch { return null }
}
